export default __webpack_public_path__ + "static/media/end_visit_icon.8d5ca3b0.svg";